// Support Center Permissions

export const SUPPORT_CENTER_TICKETS_INDEX = 96;
export const SUPPORT_CENTER_TICKETS_SHOW = SUPPORT_CENTER_TICKETS_INDEX;
export const SUPPORT_CENTER_TICKETS_DELETE = 97;
export const SUPPORT_CENTER_TICKETS_CHANGE_STATUS = 98;
export const SUPPORT_CENTER_TICKETS_SEND_REPLY = 99;
export const SUPPORT_CENTER_TICKETS_RESTORE = 1382;
